// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/tooltip.scss';
import React from 'react';
import { Tooltip } from 'react-tooltip';
import { TooltipBehavior } from './TooltipTypes';
export const TooltipClick = () => {
    return (React.createElement(Tooltip, { id: TooltipBehavior.Click, offset: 5, openOnClick: true, closeEvents: { mouseleave: true, blur: true, click: true } }));
};
